import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Button, Icon, Link, Paper, Rating, Tooltip, Typography, useTheme
} from "@mui/material";
import { DataGrid, GridActionsCellItem, GridColDef, GridEventListener } from "@mui/x-data-grid";
import Grid from '@mui/material/Grid2';
import { FranquiaService, IDadosEscalacaoPontuacao, IDadosRetornoEscalacaoFranquiaPontuacao, IDetalheFranquia, IEscalacaoPontuacao, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { Loading } from "../../shered/components/loading/Loading";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";

import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";

import dayjs from "dayjs";
import { ptBR } from '@mui/x-data-grid/locales';
import { ArrowDropDown, ArrowDropUp, ArrowLeft, ArrowRight } from "@mui/icons-material";
import { LigaService } from "../../shered/services/api/liga/LigaService";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { DisputaService } from "../../shered/services/api/disputa/DisputaService";

export const DetalheDeEscalacaoPontuacao: React.FC = () => {
    const theme = useTheme();
    const { id } = useParams<"id">();
    const user = CookieService.get("access_user");
    const { formRef, save } = useVForm();
    const { themeName } = useAppThemeContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [parametroDecrypt, setParametroDecrypt] = useState<string | undefined>("");
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, logout } = useAuthContext();
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [showEscalacaoRealizada, setShowEscalacaoRealizada] = useState(false);
    const [dadosEscalacao, setDadosEscalacao] = useState<IEscalacaoPontuacao>();
    const [escalacaoRows, setEscalacaoRows] = useState<IDadosRetornoEscalacaoFranquiaPontuacao[]>([]);
    const [minhaFranquia, setMinhaFranquia] = useState(false);
    const [nomeFranquia, setNomeFranquia] = useState("");
    const [codigoRodada, setCodigoRodada] = useState<number>(0);
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [travarEscalacao, setTravarEscalacao] = useState<boolean>(false);
    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [codigoFranquia, setCodigoFanquia] = useState(0);
    const [codigoCalendario, setCodigoCalendario] = useState<number>(0);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    function changePosition(arr: IDadosRetornoEscalacaoFranquiaPontuacao[], from: number, to: number) {
        arr.splice(to, 0, arr.splice(from, 1)[0]);
        return arr;
    };

    const moveObject = (arr: IDadosRetornoEscalacaoFranquiaPontuacao[], targetValue: any, newIndex: number) => {
        let target = arr.find(value => value["codigo"] === targetValue);
        const newArray = arr.filter(value => value["codigo"] != targetValue);
        if (target !== undefined) {
            newArray.splice(newIndex - 1, 0, target);
        }

        const result = newArray.map((m, i) => ({
            codigo: i + 1,
            codUsuCriacao: m.codUsuCriacao,
            codigo_Jogador: m.codigo_Jogador,
            dtCriacao: m.dtCriacao,
            foto_Jogador: m.foto_Jogador,
            nome_Jogador: m.nome_Jogador,
            ordem: i + 1,
            playOff: m.playOff,
            media_Minutos: m.media_Minutos,
            peso_Total: m.peso_Total,
            peso_Total_Minutos: m.peso_Total_Minutos,
            posicao_1: m.posicao_1,
            posicao_2: m.posicao_2,
            posicao_3: m.posicao_3,
            escalacao_Apta: m.escalacao_Apta
        }));

        return result;
    }

    const reordenarEscalacao = (arr: IDadosRetornoEscalacaoFranquiaPontuacao[]) => {

        const result = arr.map((m, i) => ({
            codigo: i + 1,
            codUsuCriacao: m.codUsuCriacao,
            codigo_Jogador: m.codigo_Jogador,
            dtCriacao: m.dtCriacao,
            foto_Jogador: m.foto_Jogador,
            nome_Jogador: m.nome_Jogador,
            ordem: i + 1,
            playOff: m.playOff,
            media_Minutos: m.media_Minutos,
            peso_Total: m.peso_Total,
            peso_Total_Minutos: m.peso_Total_Minutos,
            posicao_1: m.posicao_1,
            posicao_2: m.posicao_2,
            posicao_3: m.posicao_3,
            escalacao_Apta: m.escalacao_Apta,


        }));

        return result;
    }

    const handleAlterarOrdem = async (params: any, tipo: number) => {
        let to: number = 0;
        if (tipo === 1) {
            to = params.ordem + 1;
            setEscalacaoRows(moveObject(escalacaoRows, to, params.ordem));
        } else {
            to = params.ordem - 1;
            setEscalacaoRows(moveObject(escalacaoRows, to, params.ordem));
        }
    }

    const handleAlterarPosicao = async (e: any, params: any, tipo: number, direcao: string) => {
        let atual = tipo === 1 ? params.posicao_1 : tipo === 2 ? params.posicao_2 : params.posicao_3;
        let futura = tipo === 1 && direcao === "D" ? params.posicao_2 : tipo === 3 && direcao === "E" ? params.posicao_2 :
            tipo === 2 && direcao === "E" ? params.posicao_1 : params.posicao_3;       
        let alteracao = escalacaoRows.find(f => f.codigo === params.codigo);
        let newEscalacao = escalacaoRows.filter(f => f.codigo !== params.codigo);

        if (alteracao != null) {
            if (tipo === 1) {
                alteracao.posicao_1 = futura;
                alteracao.posicao_2 = atual;
                alteracao.posicao_3 = params.posicao_3;
            }
            else if (tipo === 3) {
                alteracao.posicao_1 = params.posicao_1;
                alteracao.posicao_2 = atual;
                alteracao.posicao_3 = futura;
            }
            else if (tipo === 2 && direcao === "E") {

                alteracao.posicao_1 = atual;
                alteracao.posicao_2 = futura;
                alteracao.posicao_3 = params.posicao_3;
            }
            else if (tipo === 2 && direcao === "D") {
                alteracao.posicao_1 = params.posicao_1;
                alteracao.posicao_2 = futura;
                alteracao.posicao_3 = atual;
            }
            newEscalacao.push(alteracao);
        }
        setEscalacaoRows(newEscalacao.sort((a, b) => a.codigo > b.codigo ? 1 : -1));
    }

    const columnsEscalacao: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'CÓDIGO',
            width: 90,
            //flex: 1,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'ordem',
            headerName: UtilidadeService.isMobile() ? "#" : 'ORDEM',
            width: UtilidadeService.isMobile() ? 60 : 90,
            //flex: 1,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center",
            sortable: false
        },
        {
            field: 'actions',
            headerName: '',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            sortable: false,
            width: UtilidadeService.isMobile() ? 55 : 120,
            getActions: (params) => [
                <GridActionsCellItem
                    sx={{ padding: UtilidadeService.isMobile() ? 0 : 1 }}
                    icon={
                        <Tooltip title="Abaixo">
                            {params.row.ordem < escalacaoRows.length ? (
                                <ArrowDropDown sx={{ color: "#66bb6a", fontSize: 28 }} />
                            ) : <></>
                            }
                        </Tooltip>}
                    label="Abaixo"
                    onClick={() => handleAlterarOrdem(params.row, 1)}
                />,
                <GridActionsCellItem
                    sx={{ padding: UtilidadeService.isMobile() ? 0 : 1 }}
                    icon={
                        <Tooltip title="Acima">
                            {params.row.ordem > 1 ? (
                                <ArrowDropUp sx={{ color: "#E91309", fontSize: 28 }} />
                            ) : <></>
                            }
                        </Tooltip>
                    }
                    label="Acima"
                    onClick={() => handleAlterarOrdem(params.row, 2)}
                />
            ]
        },
        {
            field: 'foto_Jogador',
            headerName: UtilidadeService.isMobile() ? "" : 'FOTO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            editable: false,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ?
                <img src={params.value} alt={params.value} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        //currentTarget.style.borderRadius = "25%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "50px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "50px";
                    }}
                />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />,
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 250,
            editable: false,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'media_Minutos',
            headerName: UtilidadeService.isMobile() ? "MIN" : 'MINUTOS',
            headerClassName: 'super-app-theme--header',
            width: UtilidadeService.isMobile() ? 80 : 150,
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0,00",
            align: "center",
            headerAlign: "center",
            sortable: false

        },
        {
            field: 'peso_Total',
            headerName: "TOTAL",
            headerClassName: 'super-app-theme--header',
            width: UtilidadeService.isMobile() ? 80 : 150,
            renderCell: (params) => params.value !== null ? params.value.toFixed(3).replace(".", ",") : "0,000",
            align: "center",
            headerAlign: "center",
            sortable: false

        },
        {
            field: 'peso_Total_Minutos',
            headerName: 'FPM',
            headerClassName: 'super-app-theme--header',
            width: UtilidadeService.isMobile() ? 80 : 150,
            renderCell: (params) => params.value !== null ? params.value.toFixed(3).replace(".", ",") : "0,000",
            align: "center",
            headerAlign: "center",
            sortable: false
        },
        {
            field: 'posicao_1',
            headerName: UtilidadeService.isMobile() ? "POS. 1" : 'POSIÇÃO 1',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            width: UtilidadeService.isMobile() ? 80 : 150,
            renderCell: (params) => [
                <GridActionsCellItem
                    style={{ fontSize: UtilidadeService.isMobile() ? 11 : 16 }}
                    icon={
                        <>
                            {params.row.posicao_1}
                            {params.row.posicao_2 !== undefined && params.row.posicao_2 !== null ? (
                                <Tooltip title="Posição 2">
                                    <ArrowRight sx={{ color: "#29b6f6", fontSize: 28 }} />
                                </Tooltip>
                            ) : <></>}
                        </>
                    }
                    label="Posição 1"
                    onClick={(e) => handleAlterarPosicao(e, params.row, 1, "D")}
                />
            ]
        },
        {
            field: 'posicao_2',
            headerName: UtilidadeService.isMobile() ? "POS. 2" : 'POSIÇÃO 2',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            width: UtilidadeService.isMobile() ? 80 : 150,
            renderCell: (params) => [
                <GridActionsCellItem
                    style={{ fontSize: UtilidadeService.isMobile() ? 11 : 16 }}
                    icon={params.row.posicao_2 !== undefined && params.row.posicao_2 !== null ? (
                        <Tooltip title="Posição 1">
                            <ArrowLeft sx={{ color: "#29b6f6", fontSize: 28 }} />
                        </Tooltip>
                    ) : <></>}

                    label="Posicao 2"
                    onClick={(e) => handleAlterarPosicao(e, params.row, 2, "E")}
                />,
                <GridActionsCellItem
                    style={{ fontSize: UtilidadeService.isMobile() ? 11 : 16 }}
                    icon={params.row.posicao_2 !== undefined && params.row.posicao_2 !== null ? (
                        <>
                            {params.row.posicao_2}
                            {params.row.posicao_3 !== undefined && params.row.posicao_3 !== null ? (
                                <Tooltip title="Posição 3">
                                    <ArrowRight sx={{ color: "#29b6f6", fontSize: 28 }} />
                                </Tooltip>
                            ) : <></>
                            }
                        </>
                    ) : <></>
                    }

                    label="Posição 2"
                    onClick={(e) => handleAlterarPosicao(e, params.row, 2, "D")}
                />
            ]
        },
        {
            field: 'posicao_3',
            headerName: UtilidadeService.isMobile() ? "POS. 3" : 'POSIÇÃO 3',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            width: UtilidadeService.isMobile() ? 80 : 150,
            renderCell: (params) => [
                <GridActionsCellItem
                    style={{ fontSize: UtilidadeService.isMobile() ? 11 : 16 }}
                    icon={params.row.posicao_3 !== undefined && params.row.posicao_3 !== null ? (
                        <>
                            <Tooltip title="Posição 2">
                                <ArrowLeft sx={{ color: "#29b6f6", fontSize: 28 }} />
                            </Tooltip>
                            {params.row.posicao_3}
                        </>
                    ) : <></>}
                    label="Posição 3"
                    onClick={(e) => handleAlterarPosicao(e, params.row, 3, "E")}
                />
            ]
        },
    ];

    useEffect(() => {
        setIsLoading(true);
        const codigoLisCrypt = UtilidadeService.crypt("0");
        let parametros: string | undefined = "";

        if (id !== undefined) {
            parametros = UtilidadeService.decrypt(id.toString());
            if (parametros === "" || parametros === undefined) {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                setIsLoading(false);

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Dados inválidos!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar(`/liga/calendario/${id}`);
                return;
            }
            setParametroDecrypt(parametros);
        }
        else {
            setRedirecionar("/dashboard");
        }
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0" || codigoLiga === undefined) {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("/dashboard");
            return;
        }

        const rodada = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[0];
        const minhafranquia = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[3];
        const codCalendario = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[1];
        const codFranquia = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[2];
        const tipoEscalacao = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[4];
        const codTemporada = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[5];

        const fetchData = async () => {
            setIsLoading(false);
            setCodigoRodada(Number(rodada));
            await LigaService.getJogosNBAPorLigaTemporadaRodada(Number(codigoLiga), Number(codTemporada), Number(rodada), Number(codCalendario))
                .then((result) => {
                    setIsLoading(false);
                    const lst = result.dado;
                    let travar = false;
                    if (lst.length > 0) {
                        let firstList = lst.sort((a, b) => Number(new Date(a.data_Inicio)) - Number(new Date(b.data_Inicio))).filter(e => { return e !== null });
                        travar = user.administrador ? false : firstList[0].rodada_Iniciada;
                        setTravarEscalacao(travar);
                    }

                    setMinhaFranquia((minhafranquia === "true" && !travar) || user.administrador);
                    setCodigoCalendario(Number(codCalendario));
                    setCodigoTemporada(Number(codTemporada));
                    setCodigoRodada(Number(rodada));
                    setCodigoFanquia(Number(codFranquia));
                    CarregarEscalacao(Number(codCalendario), Number(codFranquia), travar);
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    if (errors.response != undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados da escalação! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/liga/calendario/${codigoLisCrypt}`);
                        return;
                    }
                });

        }
        fetchData();
        setRemoveLoading(true);
    }, []);


    const CarregarEscalacao = async (codCalendario: number, codigoFranquia: number, rodadaFinalizada: boolean) => {
        await FranquiaService.getEscalacaoFranquiaPontuacao(codCalendario, codigoFranquia)
            .then((result) => {
                setIsLoading(false);
                let dadosRetornoEscalacao = result.dado;
                setDadosEscalacao(dadosRetornoEscalacao);
                setShowEscalacaoRealizada(dadosRetornoEscalacao.escalacao_Realizada);
                setEscalacaoRows(rodadaFinalizada ? dadosRetornoEscalacao.escalacao : reordenarEscalacao(dadosRetornoEscalacao.escalacao.filter(f => f.escalacao_Apta)));
                setNomeFranquia(dadosRetornoEscalacao.nome_Franquia);


            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");

                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar a escalação do time. Favor tentar novamente mais tarde e caso o problema persista, entrar em contato com a TI. ",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleSave = async () => {
        setIsLoading(true);
        setIsLoading(false);
        let lstDadosEscalacao: IDadosEscalacaoPontuacao[] = [];

        escalacaoRows.map(m => {
            lstDadosEscalacao.push({
                codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                codigo_Franquia: Number(parametroDecrypt?.split("/")[2]),
                codigo_Jogador: m.codigo_Jogador,
                codigo_Liga: Number(codigoLiga),
                ordem: m.codigo,
                posicao_1: m.posicao_1,
                posicao_2: m.posicao_2,
                posicao_3: m.posicao_3,
                codUsuCriacao: user.codUsuario,
            })
        });
        await FranquiaService.CreateEscalacaoPontuacao(lstDadosEscalacao)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Escalação realizada com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar(`/liga/calendario/${codigoRodada}`);

            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível salvar os dados da escalação! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    //setRedirecionar(`/liga/calendario/${codigoLisCrypt}`);
                    return;
                }
            });
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    };

    const MyCustomNoRowsOverlay = () => (
        <Grid container size={{ xs: 12, sm: 12 }} paddingTop={2} display="flex" justifyContent="center" textAlign="center"  >
            {!removeLoading ? <Loading />
                : <Typography>Sem Registro(s)</Typography>
            }
        </Grid>
    );


    const handleImportarEscalacao = async () => {
        let rodadaAnterior = codigoRodada - 1;
        if (rodadaAnterior <= 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: `Não é possível importar a escalação na primeira rodada!`,
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        //Number(codigoLiga)

        await DisputaService.getCalendarioAnterior(Number(codigoLiga), codigoTemporada, rodadaAnterior, codigoFranquia)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                let dadosRetorno = result.dado;
                if (dadosRetorno !== undefined) {
                    //setDadosCalendarioAnterior(dadosRetorno);
                    CarregarEscalacao(Number(dadosRetorno.codigo), codigoFranquia, false);
                }

            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });

    }


    const handleRedirect: GridEventListener<'rowClick'> = (params) => {
        let crypt = UtilidadeService.crypt(`J|${params.row.codigo.toString()}|0`);
        navigate(`/liga/jogadores/detalhe/${crypt}`);
    }

    return (
        <LayoutBaseDePagina
            titulo={`Escalação ${nomeFranquia}`}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={minhaFranquia && !travarEscalacao}
                    mostrarBotaoCancelar={minhaFranquia}
                    desabilitarBotaoSalvar={isLoading || !removeLoading}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate(`/liga/calendario/${UtilidadeService.crypt((codigoRodada - 1).toString())}`)}
                    aoClicarEmCancelar={() => navigate(0)}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={3}>
                        <Grid container size={{ xs: 12, sm: 12 }}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6">Escalação</Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} paddingBottom={UtilidadeService.isMobile() ? 0 : 1}>
                                <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, paddingBottom: 1, fontWeight: 600 }}>{`Escalação ${minhaFranquia === true ? "Minha Franquia" : nomeFranquia} - Rodada: ${codigoRodada}`}</Typography>
                                <Typography sx={{ display: showEscalacaoRealizada ? "none" : "flex", fontSize: UtilidadeService.isMobile() ? 10 : 16, color: "#fbc02d", paddingBottom: 1, fontWeight: 600, textDecoration: "underline" }}>OBS: Escalação ainda não realizada!</Typography>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 3 }} height={UtilidadeService.isMobile() ? "32px" : "38px"}
                                display={(travarEscalacao || !minhaFranquia || codigoRodada === 1) ? "none" : "flex"} justifyContent="center" justifyItems="center" >
                                <Button
                                    fullWidth
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    onClick={() => handleImportarEscalacao()}
                                    endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>import_contacts</Icon>}>
                                    <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }} > {UtilidadeService.isMobile() ? "Importar" : "Importar Escalação"}</span>
                                </Button>
                            </Grid>
                            <Grid display={isLoading ? "flex" : "none"} size={{ xs: 12 }} margin={UtilidadeService.isMobile() ? 0 : 1} paddingBottom={UtilidadeService.isMobile() ? 0 : 1}>
                                {!removeLoading && <Loading />}
                            </Grid>
                            <Box sx={{
                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                '& .super-app-theme--header': {
                                    backgroundColor: theme.palette.common.black,
                                    color: theme.palette.common.white
                                },
                                '& .super-app.negative': {
                                    color: 'red',
                                    fontWeight: 'bold'
                                },
                                '& .super-app.positive': {
                                    color: themeName === "light" ? "black" : "auto",
                                },
                            }}>
                                <DataGrid
                                    getRowId={(rows) => rows.codigo}
                                    rows={escalacaoRows}
                                    columns={columnsEscalacao}
                                    columnVisibilityModel={{ codigo: false }}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 24,
                                            },
                                        },
                                    }}
                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                    pageSizeOptions={[24, 50, 100]}
                                    autoHeight
                                    slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                    disableRowSelectionOnClick
                                    disableColumnFilter
                                    disableColumnMenu
                                    sx={{
                                        fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                    }}

                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
}